import { BaseStore } from 'fluxible/addons';

export default class BookCalculatorAttributesStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.attributes = {};
    }

    updateAttribute({ key, value }) {
        this.attributes[key] = value;
        this.emitChange();
    }

    loadInitialData(attributes) {
        this.attributes = attributes;
        this.emitChange();
    }

    unselectAttributesByKey(keys) {
        keys.forEach(key => {
            this.attributes[key]['is_required'] = false;
        });

        this.emitChange();
    }

    getState() {
        return this.attributes;
    }
}

BookCalculatorAttributesStore.storeName = 'BookCalculatorAttributesStore';

BookCalculatorAttributesStore.handlers = {
    UPDATE_ATTRIBUTE: 'updateAttribute',
    LOAD_INITIAL_ATTRIBUTES: 'loadInitialData',
    UNSELECT_ATTRIBUTES: 'unselectAttributesByKey',
};
